export default __webpack_public_path__ + "i18n/nl.06d30dafc463d485dc5db3dc1e464835.json";